import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Category {
  id: string;
  selected: boolean;
  [key: string]: any;
}

interface FeedState {
  categories: Category[];
  canGenerateFeed: boolean;
  canViewFeed: boolean;
}

const initialState: FeedState = {
  categories: [],
  canGenerateFeed: false,
  canViewFeed: false,
};

const feedSlice = createSlice({
  name: 'feed',
  initialState,
  reducers: {
    setCategories(state, action: PayloadAction<Category[]>) {
      state.categories = action.payload;
    },
    toggleCategory(state, action: PayloadAction<string>) {
      const category = state.categories.find(cat => cat.id === action.payload);
      if (category) {
        category.selected = !category.selected;
      }
    },
    resetCategories(state) {
      state.categories.forEach(cat => (cat.selected = false));
    },
    setCanGenerateFeed(state, action: PayloadAction<boolean>) {
      state.canGenerateFeed = action.payload;
    },
    setCanViewFeed(state, action: PayloadAction<boolean>) {
      state.canViewFeed = action.payload;
    },
  },
});

export const {
  setCategories,
  toggleCategory,
  resetCategories,
  setCanGenerateFeed,
  setCanViewFeed,
} = feedSlice.actions;

export const selectFeed = (state: any) => state.feed;
export const selectFeedCategories = (state: any) => state.feed.categories;
export const selectCanGenerateFeed = (state: any) => state.feed.canGenerateFeed;
export const selectCanViewFeed = (state: any) => state.feed.canViewFeed;

export default feedSlice.reducer;
